import { queryOptions, useQuery } from "@tanstack/react-query";
import type { OrganisationHierarchy } from "./organisations.types";
import { FORMS_API_BASE_ENDPOINT } from "./constants";
import { api } from "./apiClient";
import { prefetch } from "./prefetch";

const BASE_ENDPOINT = `${FORMS_API_BASE_ENDPOINT}/organisations`;

const organisationsKeys = {
  all: () => ["organisations"],
  hierarchy: () => [...organisationsKeys.all(), "hierarchy"] as const,
};

/** Get organisation hierarchy */
const getOrganisationHierarchyQueryOptions = () => {
  return queryOptions({
    queryKey: organisationsKeys.hierarchy(),
    queryFn: () => api.get(`${BASE_ENDPOINT}/hierarchy`) as Promise<OrganisationHierarchy>,
    throwOnError: true,
  });
};
export const prefetchOrganisationHierarchy = () => prefetch(getOrganisationHierarchyQueryOptions());
export const useGetOrganisationHierarchy = () => {
  return useQuery(getOrganisationHierarchyQueryOptions());
};
